import { render } from "./highCharts.vue?vue&type=template&id=580d6024"
import script from "./highCharts.vue?vue&type=script&lang=js"
export * from "./highCharts.vue?vue&type=script&lang=js"

import "./highCharts.vue?vue&type=style&index=0&id=580d6024&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__